import { View } from "ui/atoms/view";
import GoBack from "ui/molecules/common/GoBack";
import { usePathname } from "expo-router";
import { UrgentConcernsTemplate } from "app/features/urgentConcerns/templates/UrgentConcernsTemplate";

export function UrgentConcernsScreen() {
  const pathname = usePathname();
  const newPath = pathname.split("/").slice(0, -1).join("/");

  return (
    <View className="resident-container">
      <View className="flex-row justify-between mb-4">
        <GoBack path={newPath} />
      </View>
      <UrgentConcernsTemplate />
    </View>
  );
}
